exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-135ce384] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n  /* #E4E5E7 */\n}\n.headline[data-v-135ce384] {\n  font-family: \"Moderat\" !important;\n  font-size: 14px !important;\n  font-weight: 100;\n  line-height: 32px !important;\n  letter-spacing: 3px !important;\n}\n", ""]);

// exports
